import React from 'react';
import Field from './field';

function HiddenInput(_ref) {
  var name = _ref.name,
      value = _ref.value;
  return /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: name,
    value: value
  });
}

function HiddenField(_ref2) {
  var name = _ref2.name;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement(Field, {
    name: name,
    Input: HiddenInput
  }));
}

export default HiddenField;